export const challengeOverlay = [
  'tw:fixed tw:inset-0 tw:z-9999 tw:flex tw:items-center tw:justify-center',
  'tw:bg-black/50 tw:p-base',
].join(' ');

export const challengeDialog = [
  'tw:flex tw:w-full tw:max-w-[404px] tw:flex-col tw:gap-small',
  'tw:rounded-16 tw:bg-white tw:p-huge tw:shadow-[0_12px_32px_rgba(38,48,61,0.2)]',
].join(' ');

/** Header row: shield, title block, refresh. */
export const challengeHeader = 'tw:flex tw:items-start tw:gap-small';

export const challengeHeaderText = 'tw:flex tw:flex-1 tw:flex-col';

export const challengeTitle = 'tw:text-16 tw:font-semibold tw:text-font';

export const challengeRefreshButton = [
  'tw:flex tw:h-[44px] tw:w-[44px] tw:shrink-0 tw:items-center tw:justify-center',
  // Pull the 44px tap target back to the 28px visual box the design specifies, so the row keeps
  // its height while the button stays large enough to hit on a phone.
  'tw:-my-micro tw:-mr-micro',
  'tw:cursor-pointer tw:rounded-4 tw:text-gray-dark tw:transition-colors tw:hover:bg-gray-lighter',
  'tw:focus-visible:outline-2 tw:focus-visible:outline-offset-2 tw:focus-visible:outline-primary',
].join(' ');

/** Wraps the puzzle so every variant gets identical vertical rhythm. */
export const challengeBody = 'tw:flex tw:flex-col tw:gap-small';
